// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper___Z1uss","icon":"icon___RipS4","title":"title___wln_3","text":"text___i72KB"};